export const mlReasons = [
    {
        title: "High Salary Potential",
        description: (
            <>
                Machine Learning professionals can access{" "}
                <span className="highlight">
                    high-paying career opportunities
                </span>{" "}
                across technology, finance, healthcare, and other industries.
            </>
        ),
    },

    {
        title: "Explosive Job Growth",
        description: (
            <>
                Demand for AI, Machine Learning, and Data Science skills
                continues to grow as organizations increasingly adopt{" "}
                <span className="highlight-blue">
                    intelligent and data-driven technologies
                </span>
                .
            </>
        ),
    },

    {
        title: "Core Technology of Big Brands",
        description: (
            <>
                Machine Learning powers applications such as{" "}
                <span className="tech-tag">Search</span>
                <span className="tech-tag">Recommendations</span>
                <span className="tech-tag">Fraud Detection</span>
                <span className="tech-tag">Self-Driving Systems</span>
                {" "}used across major technology platforms.
            </>
        ),
    },

    {
        title: "Career Acceleration & Switching",
        description: (
            <>
                Machine Learning provides opportunities for{" "}
                <span className="highlight">
                    IT professionals, analysts, developers, and engineers
                </span>{" "}
                looking to grow their careers or transition into AI-focused
                roles.
            </>
        ),
    },

    {
        title: "Real-World Impact",
        description: (
            <>
                Machine Learning is used to solve practical problems such as{" "}
                <span className="highlight-blue">
                    disease diagnosis, fraud detection, forecasting, and
                    recommendation systems
                </span>
                .
            </>
        ),
    },

    {
        title: "Foundation for AI and Deep Learning",
        description: (
            <>
                Machine Learning provides a strong foundation for advanced
                technologies including{" "}
                <span className="tech-tag">Deep Learning</span>
                <span className="tech-tag">NLP</span>
                <span className="tech-tag">Computer Vision</span>
                <span className="tech-tag">Generative AI</span>.
            </>
        ),
    },

    {
        title: "Industry-Agnostic Applications",
        description: (
            <>
                Machine Learning is applied across{" "}
                <span className="tech-tag">Banking</span>
                <span className="tech-tag">Healthcare</span>
                <span className="tech-tag">Retail</span>
                <span className="tech-tag">Education</span>
                <span className="tech-tag">Logistics</span>
                {" "}and many other industries.
            </>
        ),
    },

    {
        title: "Abundance of Learning Resources",
        description: (
            <>
                Open-source technologies make it easier to learn, experiment,
                and build ML solutions using{" "}
                <span className="tech-tag">Scikit-learn</span>
                <span className="tech-tag">TensorFlow</span>
                <span className="tech-tag">PyTorch</span>.
            </>
        ),
    },

    {
        title: "Future-Proof Your Career",
        description: (
            <>
                Machine Learning is an important part of{" "}
                <span className="highlight">
                    digital transformation, automation, and intelligent
                    applications
                </span>
                , making ML skills valuable across modern technology roles.
            </>
        ),
    },

    {
        title: "Be a Creator, Not Just a Consumer",
        description: (
            <>
                Learn how machines learn from data and start building{" "}
                <span className="highlight-blue">
                    smart applications, recommendation engines, chatbots, and
                    forecasting systems
                </span>
                .
            </>
        ),
    },
];